// App version information (Perplexity-style versioning)
const MAJOR_VERSION = 1;

// Generate version in format: major.YYMMDD.build (commit)
const generateVersionString = () => {
  const now = new Date();
  const year = now.getFullYear().toString().slice(-2); // Last 2 digits of year
  const month = (now.getMonth() + 1).toString().padStart(2, "0");
  const day = now.getDate().toString().padStart(2, "0");
  const dateString = `${year}${month}${day}`;

  // For now, use a simple build number based on current timestamp
  // In production, this could be git commit count or CI build number
  const buildNumber = Math.floor(Date.now() / 1000) % 1000; // Last 3 digits of unix timestamp

  return `${MAJOR_VERSION}.${dateString}.${buildNumber}`;
};

const generateCommitNumber = () => {
  // For now, use a simple commit-like number based on timestamp
  // In production, this could be actual git commit count
  return Math.floor(Date.now() / 100000) % 10000; // 4-digit number
};

export const VERSION = generateVersionString();
export const COMMIT_NUMBER = generateCommitNumber();
export const BUILD_DATE = new Date().toISOString();
export const CACHE_VERSION = `malive-v${VERSION.replace(/\./g, "-")}-${Date.now()}`;

// Full version display string (like "Version 2.250825.2 (574)")
export const VERSION_DISPLAY = `Version ${VERSION} (${COMMIT_NUMBER})`;

// Version information for display
export const getVersionInfo = () => ({
  version: VERSION,
  versionDisplay: VERSION_DISPLAY,
  commitNumber: COMMIT_NUMBER,
  buildDate: BUILD_DATE,
  cacheVersion: CACHE_VERSION,
  environment: import.meta.env.MODE || "development",
});
